
define('text!modules/campaign/bulkedit/creatives/templates/bin_footer.html',[],function () { return '<dl class="headers weighting-flag">\n\t<dt class="header column weighting footer-title"></dt>\n\t<dd class="header column total-weight"></dd>\n\t<div class="icon-spinner-footer"></div>\n</dl>';});

